<template>
  <iframe style="height:542px; width: 100%;"
          id="ifpaybill"
          name="ifpaybill"
          src="https://bill-sb.payoo.vn/embed/mng/20535"
          frameborder="0"
          scrolling="no">
  </iframe>
</template>

<script>
import * as external from '@/assets/external.js'
export default {
  name: 'PaymentProcess',
  data () {
    return {
      contractNo: this.$route.params.contractNo
    }
  },
  mounted () {
    external.head_script('https://bill-sb.payoo.vn/Scripts/Iframe/FrameManager.js')
  }
}
</script>
